import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import TariffEditor from './TariffEditor';
import { updateTariff, addTariff } from 'utils/TariffAPIUtils';
import Store from 'stores/TariffsStore';
import TariffConfirmationButton from './TariffConfirmationButton';
import { extend } from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class TariffsEditorModal extends React.Component {
    constructor(props) {
        super(props);
        this.tariff = null;
        this.close = () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        };
        this.save = () => {
            if (this.tariff) {
                Store.reset();
                addTariff(this.tariff);
            }
            this.setState({ hasBeenEdited: false, valid: false });
        };
        this.update = (password) => {
            if (this.tariff) {
                Store.reset();
                updateTariff(this.tariff, password);
            }
            this.setState({ hasBeenEdited: false, valid: false });
        };
        this.onChange = (updatedTariff, edited, valid) => {
            this.tariff = updatedTariff;
            this.setState({ hasBeenEdited: edited, valid: valid });
        };
        this.state = { show: false, hasBeenEdited: false, valid: true };
    }
    render() {
        const { t } = this.props;
        let valid = this.state.valid;
        if (!this.tariff) {
            if (this.props.tariff) {
                this.tariff = extend({}, this.props.tariff);
            }
            else {
                valid = false;
                this.tariff = null;
            }
        }
        const newTariffMode = (!this.tariff || !this.tariff._id) ? true : false;
        const disableSaveButton = (!this.state.hasBeenEdited && !newTariffMode) || !valid;
        return (React.createElement(Modal, { show: this.props.show, className: this.props.className, onHide: this.close },
            React.createElement(Modal.Header, { closeButton: true }),
            React.createElement(Modal.Body, null,
                React.createElement(TariffEditor, { tariff: this.tariff, tariffsList: this.props.tariffsList, onChange: this.onChange })),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.close }, titleize(t('CLOSE'))),
                "\u00A0",
                React.createElement(TariffConfirmationButton, { controlTitle: newTariffMode ? titleize(t('SAVE')) : t('SAVE_CHANGES'), controlType: "button", skipConfirmation: newTariffMode, alertTitle: t('WARNING'), message: t('IMPACT_CUSTOMERS_MSG'), confirmTitle: t('CONFIRM_UPDATE'), dismissTitle: titleize(t('CANCEL')), onConfirm: newTariffMode ? this.save : this.update, disabled: disableSaveButton, id: "confirmation", store: Store }))));
    }
}
TariffsEditorModal.propTypes = {
    tariff: PropTypes.object,
    onClose: PropTypes.func,
};
export default withTranslation()(TariffsEditorModal);
